import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "reviewTools", "reviewInfo", "reviewButton", "infoButton"]

}
